// useSocialFeed — presentation layer over useClubNews: dresses the
// detected club events as social posts from fictional authors.

import { useMemo } from 'react'
import { useGameStore } from '@/store/gameStore'
import { useClubNews } from './useClubNews'
import { composeFeedPost, type FeedPostData } from '@/config/feedConfig'

export function useSocialFeed(): FeedPostData[] {
  const news = useClubNews()
  const day = useGameStore(s => s.day)

  return useMemo(
    () => news.map(item => composeFeedPost(item, day)),
    [news, day]
  )
}
